import React, { useState } from 'react';
import axios from 'axios';
import ContractForm from './ContractForm';

// ─────────────────────────────────────────────
// 계약서 직접 입력 등록
//  - 파일 업로드 없이 폼에 직접 입력해 저장한다
//  - 입력 폼은 ContractForm(공용)을 그대로 사용
// ─────────────────────────────────────────────

// 빈 계약서 초기값
const emptyDraft = () => ({
  contract_type: '',
  contract_date: '',
  contract_start_date: '',
  contract_end_date: '',
  location_sido: '',
  location_gungu: '',
  location_dong: '',
  location_jibun: '',
  location_full_address: '',
  amount_info: { payments: [], rentalType: '', depositAmount: 0, monthlyRent: 0 },
  landlord_info: [{ role: '', name: '', phone: '', address: '' }],
  tenant_info: [{ role: '', name: '', phone: '', address: '' }],
  broker_info: [{ name: '', phone: '', registrationNo: '', address: '' }],
  special_clauses: '',
  our_side: 'both',
});

const auth = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
});

export default function ContractManualEntry() {
  const [draft, setDraft] = useState(emptyDraft());
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  const save = async () => {
    // 최소 필수값 확인
    if (!draft.contract_type) { setMsg('계약 유형을 선택하세요'); return; }
    if (!draft.location_full_address) { setMsg('소재지를 입력하세요'); return; }
    if (!window.confirm('입력한 내용으로 계약서를 등록합니다. 계속할까요?')) return;

    setSaving(true);
    setMsg('저장 중...');
    try {
      // /save 는 제미나이 형식을 받으므로 DB 형식(draft)을 되돌려 보낸다
      const res = await axios.post('/api/contracts/save', {
        tempFilePath: null,          // 파일 없음 → 이미지 처리 건너뜀
        contractType: draft.contract_type,
        location: {
          sido: draft.location_sido,
          gungu: draft.location_gungu,
          dong: draft.location_dong,
          jibun: draft.location_jibun,
          fullAddress: draft.location_full_address,
        },
        parties: {
          landlords: draft.landlord_info || [],
          tenants: draft.tenant_info || [],
        },
        brokers: draft.broker_info || [],
        ourSide: draft.our_side,
        amounts: draft.amount_info,
        specialClauses: draft.special_clauses,
        contractDate: draft.contract_date,
        contractStartDate: draft.contract_start_date,
        contractEndDate: draft.contract_end_date,
      }, auth());

      if (res.data.success) {
        setMsg('✅ 등록되었습니다');
        setTimeout(() => {
          window.location.href = `/contracts/${res.data.contractId}`;
        }, 800);
      } else {
        setMsg('❌ ' + (res.data.message || '저장 실패'));
      }
    } catch (e) {
      setMsg('❌ 저장 실패: ' + (e.response?.data?.message || e.message));
    } finally {
      setSaving(false);
    }
  };

  const btn = (bg) => ({
    backgroundColor: bg, color: 'white', border: 'none',
    padding: '8px 16px', borderRadius: '4px', cursor: 'pointer', fontSize: '14px',
  });

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h1 style={{ fontSize: '20px', margin: 0 }}>✍️ 계약서 직접 입력</h1>
        {/* 버튼은 화면 우상단 고정 */}
        <div style={{
          display: 'flex', gap: '8px',
          position: 'fixed', top: '130px', right: '20px', zIndex: 1000,
          backgroundColor: 'rgba(255,255,255,0.95)',
          padding: '8px', borderRadius: '6px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        }}>
          <button onClick={() => (window.location.href = '/contracts/list')} style={btn('#757575')}>
            ❌ 취소
          </button>
          <button
            onClick={save}
            disabled={saving}
            style={{ ...btn(saving ? '#ccc' : '#4CAF50'), cursor: saving ? 'not-allowed' : 'pointer' }}
          >
            {saving ? '저장 중...' : '💾 등록'}
          </button>
        </div>
      </div>

      <div style={{ fontSize: '12px', color: '#666', marginBottom: '12px' }}>
        계약서 파일 없이 내용을 직접 입력해 등록합니다. 계약 유형과 소재지는 필수입니다.
      </div>

      <div style={{ backgroundColor: '#f5f5f5', padding: '20px', borderRadius: '8px' }}>
        <ContractForm
          value={draft}
          onChange={setDraft}
          showOurSide={true}
        />
      </div>

      {msg && (
        <div style={{
          marginTop: '12px', padding: '10px', borderRadius: '4px',
          backgroundColor: '#f1f5f9', fontSize: '13px', textAlign: 'center',
        }}>
          {msg}
        </div>
      )}

      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <button
          onClick={save}
          disabled={saving}
          style={{ ...btn(saving ? '#ccc' : '#4CAF50'), padding: '10px 24px' }}
        >
          {saving ? '저장 중...' : '💾 등록'}
        </button>
      </div>
    </div>
  );
}
